angular.module('picmonicng').controller('ReferralEmailController', [
  '$scope',
  'Shares',
  function ($scope, Shares) {
    $scope.emails = [];
    $scope.loading = false;
    $scope.$emit('endInteraction');

    $scope.add = function () {
      $scope.message = undefined; //reset the message when a new email is added
      if ($scope.email) {
        $scope.email.split(',').forEach(function (item) {
          if ($scope.emails.indexOf(item.trim()) == -1 && item.trim() != '') {
            $scope.emails.push(item.trim());
          }
        });
        $scope.email = undefined;
      }
    };

    $scope.remove = function (email) {
      $scope.emails = _.without($scope.emails, email);
    };

    $scope.send = function () {
      if (!$scope.loading) {
        $scope.loading = true;
        $scope.message = undefined;

        var data = {
          type: 'email_referral',
          emails: $scope.emails,
        };

        Shares.save(
          data,
          function () {
            $scope.loading = false;
            $scope.emails = [];
            $scope.message = 'Your referral link has been sent!';
          },
          function (response) {
            $scope.loading = false;
            $scope.message = undefined;

            if (response.data && response.data.message) {
              $scope.message = response.data.message;
            }
          }
        );
      }
    };
  },
]);
